var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid full-height" }, [
    _c(
      "div",
      {
        staticClass: "row justify-content-center align-items-center full-height"
      },
      [
        _c(
          "div",
          { staticClass: "col-10 col-sm-8 col-md-6 col-xl-6" },
          [
            _c("card", [
              _c(
                "h2",
                {
                  staticClass: "card-title text-center",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_c("strong", [_vm._v("Forget Password")])]
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row justify-content-md-center" }, [
                    _c("div", {
                      staticClass: "col-11",
                      staticStyle: { display: "none" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-11" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.user.email.rule,
                              expression: "user.email.rule"
                            }
                          ],
                          attrs: {
                            type: "email",
                            label: "E-mail",
                            placeholder: "Enter E-mail",
                            "data-vv-value-path": "user.email.value",
                            "data-vv-name": "email",
                            "cus-name": "email",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.user.email.value,
                            callback: function($$v) {
                              _vm.$set(_vm.user.email, "value", $$v)
                            },
                            expression: "user.email.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-fill btn-block",
                          attrs: {
                            type: "submit",
                            disabled: _vm.errors.any() || !_vm.isComplete
                          }
                        },
                        [_vm._v("\n                Send\n              ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "my-2" },
                        [
                          _c("router-link", { attrs: { to: "/login" } }, [
                            _vm._v("back to login")
                          ])
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ]
              )
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-425f34e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-425f34e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth/ForgetPassword.vue
// module id = l0Cq
// module chunks = 0